import { lazy } from "react";

const Base = lazy(() =>
    import("./sheet").then((module) => ({ default: module.Sheet }))
);

const Header = lazy(() =>
    import("./sheet").then((module) => ({ default: module.Sheet.Header }))
);

const Title = lazy(() =>
    import("./sheet").then((module) => ({ default: module.Sheet.Header.Title }))
);

const Subtitle = lazy(() =>
    import("./sheet").then((module) => ({
        default: module.Sheet.Header.Subtitle
    }))
);

const Body = lazy(() =>
    import("./sheet").then((module) => ({ default: module.Sheet.Body }))
);

const Footer = lazy(() =>
    import("./sheet").then((module) => ({ default: module.Sheet.Footer }))
);

const Scrollable = lazy(() =>
    import("./sheet").then((module) => ({ default: module.Sheet.Scrollable }))
);

export const Sheet = Object.assign(Base, {
    Header: Object.assign(Header, {
        Title: Title,
        Subtitle: Subtitle
    }),
    Body: Body,
    Footer: Footer,
    Scrollable: Scrollable
});
